export default {
  FORM_GROUP: {
    OPTIONAL: 'optional',
  },
};
